export default "__VITE_ASSET__CxKMBUac__"